import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Slide } from 'src/app/shared/models/slide';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddSlideComponent } from '../add-slide/add-slide.component';
import { UpdateSlideComponent } from '../update-slide/update-slide.component';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-slide-zone',
  standalone: false,
  templateUrl: './slide-zone.component.html',
  styleUrl: './slide-zone.component.scss'
})

export class SlideZoneComponent  {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  accesData: any =[];


  itemToDelete!: Slide; 
  paginatedProjets = [];
  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  searchTerm: string = '';
  filteredData: any[] = []; // Données filtrées

  constructor(
      private modalService: NgbModal,
      private paramService:ParameterService,
      private localstorage:LocalStorageService,
      private confirmationService: ConfirmationService,
      private messageService: MessageService,
      private ngxService: NgxUiLoaderService,
      private authService: AuthService,
      private fetchService:FecthDataService

  ) { 

    this.fetchService.actionCreated$.subscribe(() => {
      this.fetchData();
    });
  }

  ngOnInit(): void {
  }

fetchData() {
  this.isLoading = true;

  this.paramService.getSlideZoneArticle().subscribe(
    (response: any) => {
      this.accesData = response.data || [];
      this.filteredData = [...this.accesData];
      this.totalRecords = this.filteredData.length;
      this.updatePaginatedProjets();
      this.isLoading = false;
    },
    (error) => {
      this.isLoading = false;
    }
  );
}


  onPageChangeProjets(event) {
    this.firstProjets = event.first ;
    this.rowsProjets = event.rows ;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredData.slice(start, end);
  }

  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.accesData.filter(user =>
        user.titre.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.accesData];
    }

    this.totalRecords = this.filteredData.length;
    this.firstProjets = 0; // Revenir à la première page après le filtrage
    this.updatePaginatedProjets();
  }

  openModal() {
    this.modalService.open(AddSlideComponent, {
       centered: true,
       backdrop: 'static', 
        size:"lg"

       });
  }

  EditModal(action:any) {
    this.localstorage.saveUsersSlide(action)
      const modalRef = this.modalService.open(UpdateSlideComponent,{
        backdrop: 'static', 
        centered: true,
        size:"lg"

      }, );
  }

  
   //methode de suppression
   confirmDeletion(project: any) {
    this.confirmationService.confirm({
        message: "Êtes-vous sûr de vouloir supprimer ",
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Oui', 
        rejectLabel: 'Non', 
        accept: () => {
          this.ngxService.start();
            this.paramService.deleteSlide(project.reference).subscribe(
              (response:any)=>{
                this.ngxService.stop();
                ////console.log("la reponse du webserice",response);
                this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
                this.fetchData();
              },
              (error)=>{
                this.ngxService.stop();
                ////console.log("une erreur est survenu",error);
                this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });  
              },
            )
          },
        reject: () => {
            //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
        }
    });
  }


}